module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/Roboto-Regular.ttf
// module id = 3457
// module chunks = 0